import React from "react";
import Step from "./Step";
import { faNetworkWired, faCogs, faChartBar } from "@fortawesome/free-solid-svg-icons";

function HowItWorks() {

  return (
    <div className="bg-gray-100 py-12 px-4">
      <div className="container mx-auto">
        <div className="text-center w-full lg:w-2/3 mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold leading-tight">
            Describe how your product works
          </h2>
          <p className="text-lg py-2 text-gray-800 font-body">
            What's the problem? How will you solve it? What are the results?
          </p>
        </div>
        <div className="flex flex-col lg:flex-row lg:justify-center items-center py-4 lg:py-16">
          <Step 
            iconSrc={faNetworkWired} 
            title="Step #1"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          />
          <Step 
            iconSrc={faCogs} 
            title="Step #2"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          />
          <Step 
            iconSrc={faChartBar} 
            title="Step #3"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          />                                       
        </div>
      </div>
    </div>
  )
}

export default HowItWorks;